export default __webpack_public_path__ + "static/media/ic_four_circles.45dca8fb.svg";